import React from "react";
import "../Guess/Guess.css";

const Result = props => {
  // Debug: Log props to see what data we're receiving
  console.log('Result component props:', {
    showToppers: props.showToppers,
    toprankers: props.toprankers,
    toprankersLength: props.toprankers ? props.toprankers.length : 'undefined',
    currentPlayerName: props.userName,
    currentPlayerScore: props.score
  });

  // Function to get leaderboard data with current player info
  const getLeaderboardData = () => {
    if (!props.toprankers || props.toprankers.length === 0) return { topPlayers: [], currentPlayerRank: null };
    
    // Get top 3 players
    const topPlayers = props.toprankers.slice(0, 3);
    
    // Find current player's rank and info
    let currentPlayerRank = null;
    const currentPlayerName = props.userName;
    const currentPlayerScore = props.score;
    
    if (currentPlayerName && currentPlayerScore !== undefined) {
      // Find the current player's position in the sorted list
      const playerIndex = props.toprankers.findIndex(player => 
        player.userName === currentPlayerName && player.score === currentPlayerScore
      );
      
      if (playerIndex !== -1) {
        currentPlayerRank = {
          rank: playerIndex + 1,
          userName: currentPlayerName,
          score: currentPlayerScore,
          level: props.toprankers[playerIndex].level,
          isCurrentPlayer: true
        };
      }
    }
    
    return { topPlayers, currentPlayerRank };
  };

  const { topPlayers, currentPlayerRank } = getLeaderboardData();

  const getFinalMessage = (score) => {
    if (score >= 20) return "🏆 Snake Master! Amazing!";
    if (score >= 15) return "🥇 Excellent! You're getting good!";
    if (score >= 10) return "🥈 Great job! Keep it up!";
    if (score >= 5) return "🥉 Nice try! Practice makes perfect!";
    return "🐍 Good start! Try again!";
  }

  return (
    <div className="snake-newgame">
      <div className="game-over-modal">
        <div className="game-over-content">
          <h1 className="game-over-title">🎮 Game Over!</h1>
          <div className="final-score-section">
            <h2 className="final-message">{getFinalMessage(props.score || 0)}</h2>
            <div className="score-display">
              <span className="score-label">Final Score:</span>
              <span className="final-score">{props.score || 0}</span>
            </div>
          </div>

          {/* Show top 3 players and current player rank */}
          {props.toprankers && props.toprankers.length > 0 && (
            <div className="leaderboard-summary">
              {/* Top 3 Players Section */}
              <div className="top-players-section">
                <h3 className="section-title">🏆 Top 3 Players</h3>
                <div className="compact-leaderboard">
                  {topPlayers.map((player, index) => (
                    <div key={`top-${index}`} className="compact-leaderboard-item">
                      <span className="position">#{index + 1}</span>
                      <span className="name">{player.userName}</span>
                      <span className="score">{player.score}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Current Player Performance */}
              {currentPlayerRank && (
                <div className="current-performance-section">
                  <h3 className="section-title">🎯 Your Performance</h3>
                  <div className="performance-stats">
                    <div className="stat-item">
                      <span className="stat-label">Your Rank</span>
                      <span className="stat-value rank-highlight">#{currentPlayerRank.rank}</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-label">Total Players</span>
                      <span className="stat-value">{props.toprankers.length}</span>
                    </div>
                    <div className="stat-item">
                      <span className="stat-label">Percentile</span>
                      <span className="stat-value">Top {Math.round((currentPlayerRank.rank / props.toprankers.length) * 100)}%</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          
          <div className="game-over-actions">
            <button className="play-again-btn" onClick={props.newgame}>
              🚀 Play Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Result;
